import {Endpoint} from '@eryxcoop/appyx-comm';
import DateAdapter from "../../../adapters/DateAdapter";

export default class CreateOrderEndpoint extends Endpoint {

  adaptValues(order) {
    const dateAdapter = new DateAdapter();
    return {
      "customer": {
        "business_name": order.businessName,
        "fantasy_name": order.fantasyName,
        "code": order.customerCode,
      },
      "delivery_site": {
        "name": order.deliverySiteName,
        "address": order.deliverySiteAddress,
        "city": order.deliverySiteCity,
      },
      "delivery_date": dateAdapter.adapt(order.deliveryDate),
      "customers_order_number": this.adaptPurchaseOrderNumber(order.purchaseOrderNumber),
      "observations": order.observations,
      "sales_point": "BACKOFFICE",
      "is_free": order.isFree || false
    }
  }

  adaptPurchaseOrderNumber(purchaseOrderNumber){
    if (purchaseOrderNumber === ''){
      return null
    }
    return purchaseOrderNumber
  }

}